import React from 'react'
import {FormLayout, Modal} from '@therms/atalaya'
import {
  Alerts,
  FormikPhone,
  FormikRadio,
  useCurrentUser,
  useRPCContext,
} from '@therms/react-modules'
import {Formik} from 'formik'
import * as Yup from 'yup'
import Illustration from '@src/assets/download_mobile_app_illustration.svg'

const typeOptions = [
  {label: 'Android', value: 'android'},
  {label: 'iOS', value: 'ios'},
]

const ValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required()
    .min(14, 'Number must have 10 digits')
    .max(14, 'Number must have 10 digits'),
  type: Yup.string().oneOf(['android', 'ios']).required(),
})

interface MobileAppDownloadModalProps {
  closeHandler: () => void
}

function MobileAppDownloadModal({closeHandler}: MobileAppDownloadModalProps) {
  const {rpcService} = useRPCContext()
  const currentUser = useCurrentUser()
  const {phone} = currentUser

  const handleFormSubmit = (values) => {
    rpcService.Auth.SendMobileAppLinkSms.v1
      .call(values)
      .then(() => {
        Alerts.success('Download link successfully sent')
        closeHandler()
      })
      .catch((err) => {
        console.log('err', err)

        Alerts.error(
          'There was a problem sending the download link',
          err.message,
        )
      })
  }

  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header="Get the Mobile App"
      outsideClickClose
      width="sm"
    >
      <img alt="" className="mx-auto h-56" src={Illustration} />
      <div className="mt-lg text-color-strong text-center text-lg font-medium tracking-wide">
        The best way to handle your operations in the field
      </div>
      <div className="mt-sm mx-auto max-w-prose text-center">
        THERMS Mobile App has been designed to provide you with the tools needed
        in the process of carrying out duties and responsibilities in the field.
      </div>

      <div className="mt-xl bg-surface-subtle p-base mx-auto rounded">
        <Formik
          initialValues={{phone: phone || '', type: ''}}
          onSubmit={handleFormSubmit}
          validationSchema={ValidationSchema}
        >
          {({isSubmitting, submitForm}) => (
            <FormLayout
              heading={
                <div className="fond-medium text-color-subtle">
                  Would you like to receive a download link via text?
                </div>
              }
              horizontal={false}
              space="xs"
            >
              <FormikPhone
                label="Mobile Number"
                disabled={isSubmitting}
                maxLength={10}
                name="phone"
                placeholder="(555) 555-5555"
              />

              <FormikRadio
                name="type"
                disabled={isSubmitting}
                label="Platform"
                options={typeOptions}
              />

              <FormLayout.Controls
                disabled={isSubmitting}
                onSubmit={submitForm}
                submitting={isSubmitting}
                submitLabel="Send Text"
              />
            </FormLayout>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export {MobileAppDownloadModal}
